document.addEventListener('DOMContentLoaded', function () {
    let block = document.querySelector('.gallery-slider');
    if (typeof Splide !== 'undefined' && block) {
        new Splide('.gallery-slider', {
            type: 'loop',
            perPage: 2,
            focus: 'center',
            gap: 20,
            padding: '20%',
            arrows: false,
            pagination: false,
            autoplay: false,

            breakpoints: {
                1024: {
                    perPage: 2,
                    padding: '10%',
                },
                768: {
                    perPage: 1,
                    padding: '15%',
                }
            }
        }).mount();
    }
});